:root {
  /* Switch Input */
  --switch-width: 42px;
  --switch-height: 24px;
  --knob-size: 18px;
}

.SDSSwitch {
  width: var(--switch-width);
  height: var(--switch-height);
  background: var(--input-default);
  border-radius: var(--switch-height);
  position: relative;
  cursor: pointer;
  transition:
    background 0.4s,
    border-color 0.4s;

  appearance: none;
  border: 1px solid var(--input-default);
  display: inline-flex;
  align-items: center;
  padding: 0;
  outline: none;

  &:hover {
    border-color: var(--input-hover);
  }

  &:focus,
  &:focus-visible {
    border-color: var(--input-pressed);
    outline: 2px solid var(--brand-primary);
    outline-offset: 2px;
  }

  &--active {
    background: var(--brand-primary);
    border-color: var(--brand-primary);

    &:hover {
      border-color: var(--brand-secondary);
    }

    &:focus,
    &:focus-visible {
      border-color: var(--brand-tertiary);
    }
  }

  &--disabled {
    background: var(--input-disabled);
    cursor: default;
    border-color: var(--input-disabled);

    &:hover,
    &:focus,
    &:focus-visible {
      border-color: var(--input-disabled);
      outline: none;
    }
  }

  &--error {
    border-color: var(--status-alert);

    &:hover,
    &:focus,
    &:focus-visible {
      border-color: var(--status-alert);
    }
  }

  &--disabled.SDSSwitch--active {
    border-color: var(--brand-quaternary);
    background: var(--brand-quaternary);

    &:hover,
    &:focus,
    &:focus-visible {
      border-color: var(--brand-quaternary);
      outline: none;
    }
  }

  &--error.SDSSwitch--active {
    border-color: var(--status-alert);

    &:hover,
    &:focus,
    &:focus-visible {
      border-color: var(--status-alert);
    }
  }

  &__thumb {
    width: var(--knob-size);
    height: var(--knob-size);
    background: var(--background-fill);
    border-radius: 50%;
    transition: transform 0.3s ease;
    transform: translateX(3px);

    .SDSSwitch--active & {
      transform: translateX(calc(var(--switch-width) - var(--knob-size) - 6px));
    }

    .SDSSwitch--disabled & {
      background: var(--input-default);
    }
  }

  &__wrapper {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2, 8px);

    &--disabled {
      cursor: default;
    }
  }

  &__label {
    cursor: pointer;
    user-select: none;
    font-size: var(--body-small-size);
    line-height: var(--body-small-line-height);
    color: var(--text-primary);

    .SDSSwitch__wrapper--disabled & {
      cursor: default;
      color: var(--text-disabled);
    }
  }
}
